<template>
	<div :class="keyboardClass"></div>
</template>
<script>
import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'
import layout from 'simple-keyboard-layouts/build/layouts/korean'
export default {
	name: 'SimpleKeyboard_kr',
	props: {
		keyboardClass: {
			default: 'simple-keyboard_kr',
			type: String,
		},
		input: {
			type: String,
		},
	},
	data: () => ({
		keyboard: null,
		layout: {
			display: {
				'{bksp}': '&nbsp',
				'{retry}': '다시입력',
			},
			layout: {},
			layoutCandidates: {},
		},
	}),
	mounted() {
		this.layout.layout.default = [
			'ㅂ ㅈ ㄷ ㄱ ㅅ ㅛ ㅕ ㅑ ㅐ ㅔ',
			'ㅁ ㄴ ㅇ ㄹ ㅎ ㅗ ㅓ ㅏ ㅣ {bksp}',
			'ㅋ ㅌ ㅊ ㅍ ㅠ ㅜ ㅡ ㅒ ㅖ',
			'{retry}',
		]
		this.layout.layoutCandidates = layout.layoutCandidates
		this.keyboard = new Keyboard(this.keyboardClass, {
			onChange: this.onChange,
			onKeyPress: this.onKeyPress,
			...this.layout,
		})
	},
	methods: {
		onChange(input) {
			this.$emit('onChange', input)
		},
		onKeyPress(button) {
			this.$emit('onKeyPress', button)

			/**
			 * If you want to handle the shift and caps lock buttons
			 */
			if (button === '{shift}' || button === '{lock}') this.handleShift()
		},
		handleShift() {
			let currentLayout = this.keyboard.options.layoutName
			let shiftToggle = currentLayout === 'default' ? 'shift' : 'default'

			this.keyboard.setOptions({
				layoutName: shiftToggle,
			})
		},
	},
	watch: {
		input(input) {
			this.keyboard.setInput(input)
		},
	},
}
</script>
<style lang="scss">
.hg-button-retry {
	height: 67px !important;
	font-size: 18px;
}
.hg-candidate-box {
	display: none;
}
.hg-theme-default {
	background-color: transparent;
	font-size: 28px;
	padding-top: 10px;
}
.hg-standardBtn {
	height: 67px !important;
	span {
		padding-top: 10px;
	}
}
.hg-button-bksp {
	height: 67px !important;
	background-color: #c2c2c2 !important;
	width: 20px;
	span {
		width: 90%;
		font-size: 16px;
		background-position: center;
		background-image: url('/image/backspace-outline.svg') !important;
		background-size: contain;
		background-repeat: no-repeat;
	}
}
</style>
